<form [formGroup]="formGroup" *transloco="let t; read 'home.calculator'">
  <div formArrayName="consumptionArray"
       [ngClass]="{
  'grid grid-cols-2 gap-x-2 gap-y-2': !tariffHasTwoPrices,
  'flex flex-col': tariffHasTwoPrices
  }">
    <ng-container *ngFor="let consumption of consumptionArray.controls; let i = index; let even = even">
      <div *ngIf="tariffHasTwoPrices; else singlePrice">
        <ng-container *ngIf="even">
          <h5>{{months[i / 2] | titlecase}}</h5>
          <div class="grid grid-cols-2 gap-2">
            <psc-input
              [formControlName]="i"
              [label]="t('consumption.consumptionNT')"
              type="number"></psc-input>
            <psc-input
              [formControlName]="i+1"
              [label]="t('consumptionVT.title')"
              type="number"></psc-input>
          </div>
        </ng-container>
      </div>
      <ng-template #singlePrice>
        <psc-input
          [formControlName]="i"
          [label]="months[i] | titlecase"
          type="number"></psc-input>
      </ng-template>
    </ng-container>
  </div>

  <div class="flex gap-6 mt-10">
    <psc-button
      [label]="t('save')"
      (buttonClicked)="submit()"
      [disabled]="!formGroup.valid"
      type="primary-blue-2"></psc-button>


    <psc-button
      [label]="t('reset')"
      (buttonClicked)="reset()"
      type="secondary-yellow"></psc-button>

    <psc-button
      [label]="t('cancel')"
      (buttonClicked)="cancel.emit()"
      type="secondary-magenta"></psc-button>
  </div>

</form>
